import { render, staticRenderFns } from "./assemblyBook.vue?vue&type=template&id=37ef6fbe&scoped=true&"
import script from "./assemblyBook.vue?vue&type=script&lang=js&"
export * from "./assemblyBook.vue?vue&type=script&lang=js&"
import style0 from "./assemblyBook.vue?vue&type=style&index=0&id=37ef6fbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef6fbe",
  null
  
)

export default component.exports